module.exports = __webpack_public_path__ + "img/4-12.275b5b2d.png";